import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import './PresentationAnalysisLeftPanel.css';

const PresentationAnalysisLeftPanel = ({ 
  availableOptions, 
  selectedOptions, 
  onOptionChange, 
  onGenerate 
}) => {
  const [inputMethod, setInputMethod] = useState('auto');

  const handleGenerate = () => {
    onGenerate();
  };

  return (
    <div className="presentation-left-panel">
      {/* Header */}
      <div className="panel-header">
        <h1 className="panel-title">Earnings Presentation Analysis</h1>
        <p className="panel-description">
          Analyze earnings presentations and extract key insights from quarterly reports.
        </p>
      </div>

      {/* Input Method Tabs */}
      <div className="input-method-tabs">
        <button 
          className={`tab ${inputMethod === 'auto' ? 'active' : ''}`}
          onClick={() => setInputMethod('auto')}
        >
          Auto
        </button>
        <button 
          className={`tab ${inputMethod === 'manual' ? 'active' : ''}`}
          onClick={() => setInputMethod('manual')}
        >
          Manual
        </button>
      </div>

      {/* Configuration Sections */}
      <div className="config-sections">
        {/* Show message if no options available */}
        {(!availableOptions.banks || availableOptions.banks.length === 0) && (
          <div className="config-empty-message">
            <p>No data available for the selected country. Please ensure output mapping is generated.</p>
          </div>
        )}
        
        {/* Bank Selection */}
        {availableOptions.banks && availableOptions.banks.length > 0 && (
          <div className="config-section">
            <div className="config-label">Bank</div>
            <div className="config-buttons">
              {availableOptions.banks.map((bank) => (
                <button
                  key={bank}
                  className={`config-button ${selectedOptions.bank === bank ? 'active' : ''}`}
                  onClick={() => onOptionChange('bank', bank)}
                >
                  {bank}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Year Selection */}
        {availableOptions.years && availableOptions.years.length > 0 && (
          <div className="config-section">
            <div className="config-label">Year</div>
            <div className="config-buttons">
              {availableOptions.years.map((year) => (
                <button
                  key={year}
                  className={`config-button ${selectedOptions.year === year ? 'active' : ''}`}
                  onClick={() => onOptionChange('year', year)}
                >
                  {year}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Quarter Selection */}
        {availableOptions.quarters && availableOptions.quarters.length > 0 && (
          <div className="config-section">
            <div className="config-label">Quarter</div>
            <div className="config-buttons">
              {availableOptions.quarters.map((quarter) => (
                <button
                  key={quarter}
                  className={`config-button ${selectedOptions.quarter === quarter ? 'active' : ''}`}
                  onClick={() => onOptionChange('quarter', quarter)}
                >
                  {quarter}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Segment Selection (only for presentations) */}
        {availableOptions.segments && availableOptions.segments.length > 0 && (
          <div className="config-section">
            <div className="config-label">Segment</div>
            <div className="config-buttons">
              {availableOptions.segments.map((segment) => (
                <button
                  key={segment}
                  className={`config-button ${selectedOptions.segment === segment ? 'active' : ''}`}
                  onClick={() => onOptionChange('segment', segment)}
                >
                  {segment.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Generate Button */}
      <button 
        className="generate-button"
        onClick={handleGenerate}
        disabled={!selectedOptions.bank || !selectedOptions.year || !selectedOptions.quarter}
      >
        <RefreshCw size={16} />
        Generate
      </button>
    </div>
  );
};

export default PresentationAnalysisLeftPanel;

